import { useEffect, useState } from "react";

export function useMedia(media = 1024) {
  const [isSmallerScreen, setIsSmallerScreen] = useState(true);
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== "undefined"
      ? window.visualViewport?.width || window.innerWidth
      : 1020,
  );

  function handleResize() {
    const width = window.visualViewport?.width || window.innerWidth;
    setScreenWidth(width);
    setIsSmallerScreen(width <= media);
  }

  useEffect(() => {
    handleResize(); // Set initial values

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [media]);

  return { isSmallerScreen, screenWidth };
}
